import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import noImgAvailable from './noImgAvailable.png';
import standard from './standard.png';
import premium from './premium.png';
import css from './StripeSubscriptions.module.css';

const useStyles = makeStyles({
  root: {
    maxWidth: 345,
  },
  media: {
    height: 140,
  },
});

export default function SubscriptionOptionCard(props) {
  const classes = useStyles();

  const amount = props.amount;
  const productName = props.productName;
  const priceId = props.priceId;
  const createSubscription = props.createSubscription;
  const labelImage = props.priceId === 'price_1JVgc1EzdXC7updUSHcvm7QB' ? premium : standard;
  const subscriptionType = props.priceId === 'price_1JVgc1EzdXC7updUSc2RFQxO' ? 'premium' : 'standard';
  return (
    <Card className={classes.root} onClick={() => createSubscription(priceId)}>
      <CardActionArea>
        <CardMedia
          className={classes.media}
          image={labelImage}
          title="Contemplative Reptile"
        />
        <CardContent>
          <Typography gutterBottom variant="h5" component="h2">
            {productName}
          </Typography>
          <Typography variant="h5" color="textSecondary" component="p">
            {amount}
          </Typography>
          <Typography variant="h6" color="textSecondary" component="p">
            {subscriptionType === 'premium' ? 
              <ul>
                  <li>• benefit 1</li>
                  <li>• benefit 2</li>
              </ul> : 
              <ul>
                  <li>• benefit 3</li>
                  <li className={css.whiteText}>white text</li>
              </ul>
            }
          </Typography>
       
        </CardContent>
      </CardActionArea>
      <CardActions>
        <Button size="small" color="primary" onClick={() => createSubscription(priceId)}>
          Select
        </Button>
      </CardActions>
    </Card>
  );
}